import cn from 'classnames';

interface Props {
    imgSrc: string;
    alt: string;
    className?: string;
}

const PaymentMethodBadge = ({ imgSrc, alt, className }: Props) => {
    return (
        <div className={cn('flex justify-center border border-grey-200 rounded-lg w-[50px]', className)}>
            <img className="h-full w-auto" src={imgSrc} alt={alt} />
        </div>
    );
};

export default PaymentMethodBadge;
